import { Loader2 } from "lucide-react";

/**
 * Minimal, brand-consistent fallback shown for the brief moment a lazy-loaded route
 * chunk (admin pages, listing detail map, etc.) is being fetched. Kept intentionally
 * plain (no layout/skeleton guessing) since it only ever appears for a very short
 * window on a fast connection.
 */
const PageLoader = () => (
  <div className="min-h-[40vh] w-full flex items-center justify-center" data-testid="page-loader">
    <Loader2 className="h-6 w-6 animate-spin text-[color:var(--brand-gold-2)]" />
  </div>
);

export default PageLoader;
